import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import { ServiceBase } from 'services/servicebase';
import { Response } from 'services/models/response';
import { ToastService } from '@core/components/toasts/toasts.service';
import { ActionPlanModel } from 'services/models/corporate/action-plan/action-plan.model';

@Injectable({
  providedIn: 'root',
})
export class ActionPlanService extends ServiceBase<ActionPlanModel> {
  constructor(
    http: HttpService,
    public _toasterService: ToastService
  ) {
    super('actionplan', http, environment.apiUrl);
  }

  createEntity(input: any): ActionPlanModel {
    return ActionPlanModel.create(input);
  }

  listByReferenceId(
    referenceId: string,
    onlyFromEmployee: boolean = false
  ): Observable<Response<ActionPlanModel[]>> {
    return this.http
      .get(
        `${this.endpoint}/list-by-reference/${referenceId}?onlyFromEmployee=${onlyFromEmployee}`,
        null,
        null,
        null,
        true
      )
      .pipe(
        map(res => {
          const response = new Response<ActionPlanModel[]>();

          response.data = res.body.map(pp => ActionPlanModel.create(pp) as ActionPlanModel);
          response.count = res.headers.get('x-count');
          return response;
        })
      );
  }

  finishAction(data: ActionPlanModel): Observable<any> {
    return this.http.put(`${this.endpoint}/finish`, data);
  }

  getActionFile(actionId: string) {
    this._toasterService.showSuccess('Abrindo arquivo, aguarde...');

    this.http.get(`${this.endpoint}/${actionId}/file`, null, null, null, true).subscribe({
      next: res => {
        window.open(res.body, '_blank');
        this._toasterService.showSuccess('Operação finalizada!');
      },
      error: error => {
        this._toasterService.showError('Não foi possível abrir o arquivo.');
      },
    });
  }
}
